import { Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { User } from '@app/_models';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { CommonService } from './common.service';
import { ToastrService } from 'ngx-toastr';
import { ChatbotService } from './chatbot.service';


@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  public user: Observable<User>;
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  public isAuthSubject: BehaviorSubject<boolean>;
  public isAuthenticatedUser: Observable<boolean>;

  userProjectRole: BehaviorSubject<string>;

  constructor(private http: HttpClient, private router: Router,
    private common: CommonService, private toastr: ToastrService, private chatbotService: ChatbotService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
    this.currentUser = this.currentUserSubject.asObservable();

    this.isAuthSubject = new BehaviorSubject<boolean>(JSON.parse(localStorage.getItem('authenticated')));

  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  /* After redirecting login to default page i.e Endpoint */
  postLogin(user: any, deepLink: string) {
    // const decode = JSON.parse(atob(user));
    if(!localStorage.getItem('user')) {
      if(typeof(user)==='string') {
        const decode = JSON.parse(atob(user));
        localStorage.setItem('user', JSON.stringify(decode.response));
      }else{
        localStorage.setItem('user', JSON.stringify(user));
      }
      // localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('authenticated', 'true');
      /* Setting the about to session */
      this.common.getAbout().subscribe(data => {
        console.log(data)
        localStorage.setItem('about', JSON.stringify(data.response));
      });
      this.common.getDefaultProject().subscribe(data => {
        localStorage.setItem('defaultUserConfig', JSON.stringify(data.response.userSettings));
      });
    }
    this.currentUserSubject.next(JSON.parse(localStorage.getItem('user')));
    this.isAuthSubject.next(JSON.parse(localStorage.getItem('authenticated')));
    // /* Auto Redirection  if deeplink*/
    this.restoreLastLoginPage(deepLink);
      this.chatbotService.loadChatbot(JSON.parse(localStorage.getItem('user')));
  }

  sessionCheckBackend() {
    return this.http.get<any>(`${environment.apiUrl}authentication/sessionCheck`);
  }

  loginWithoutOkta(){
    return this.http.get<any>(environment.loginUrl,{
      headers: {'username': environment['userName']}
   })
  }

  isAuthenticated() {
    return this.isAuthSubject.value;
  }

  userHasPermission(roles) {
    let found = false;
    const isSuperAdmin = this.currentUserSubject.value['superAdmin'];
    const userRoleByProject = (this.userProjectRole) ? this.userProjectRole.value : false;

    if (!this.isAuthenticated()) return false;

    if (isSuperAdmin) {
      found = true;
    } else if (userRoleByProject) {
      roles.forEach(function (value) {
        if (userRoleByProject.indexOf(value) >= 0) {
          found = true;
          return;
        }
      });
    }
    return found;
  }

  getUserRoleByProject(role) {
    this.userProjectRole = new BehaviorSubject<string>(role);
  }

  restoreLastLoginPage(deepLink: string) {
    if (deepLink) {
      window.location.href = deepLink;
      this.toastr.success("Welcome back");
    } else {
      this.common.getMyProjects().subscribe((data) => {
        if(data.response !== null && data.response.length > 0) {
          this.router.navigate(['/endpoint'], { queryParams: { page: 1, size: 15 } });
          let user = JSON.parse(localStorage.getItem('user'));
          this.toastr.success("Welcome " + user.userMetadata.firstName);
        } else {
          this.router.navigate(['/home'], { queryParams: { newUser: true } });
        }
      });
    }
  }

  logout() {
    this.http.get<any>(environment.apiUrl + 'authentication/logout').pipe().subscribe(data => {
      this.clearAllData();
      this.router.navigate(['/home']);
      this.chatbotService.HideChatbot();
    });
  }

  clearAllData() {
    localStorage.removeItem('user');
    localStorage.removeItem('authenticated');
    localStorage.removeItem('about');
    localStorage.removeItem('defaultUserConfig');
    this.currentUserSubject.next(null);
    this.isAuthSubject.next(false);
  }

}
